export interface FilterState {
  genres: string[];
  region: string;
  yearRange: string;
  sort: string;
}

interface FilterSidebarProps {
  genres: string[];
  regions: string[];
  value: FilterState;
  onChange: (patch: Partial<FilterState>) => void;
  onReset: () => void;
}

const yearOptions = [
  { label: "全部年份", value: "" },
  { label: "2023 - 2025", value: "2023-2025" },
  { label: "2020 - 2022", value: "2020-2022" },
  { label: "2015 - 2019", value: "2015-2019" },
  { label: "2010 - 2014", value: "2010-2014" },
];

const sortOptions = [
  { label: "最新更新", value: "latest" },
  { label: "最热播放", value: "hot" },
  { label: "评分最高", value: "rating" },
];

export default function FilterSidebar({
  genres,
  regions,
  value,
  onChange,
  onReset,
}: FilterSidebarProps) {
  const pill = (active: boolean) =>
    `whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
      active
        ? "bg-primary-500 text-background-50"
        : "bg-background-100 text-foreground-600 hover:bg-secondary-100"
    }`;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-lg text-primary-500" aria-hidden="true" />
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="whitespace-nowrap text-xs font-medium text-accent-600 transition-colors hover:text-accent-700"
        >
          重置筛选
        </button>
      </div>

      <div>
        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">类型</h3>
        <div className="flex flex-wrap gap-2">
          {genres.map((genre) => (
            <button
              key={genre}
              type="button"
              onClick={() => {
                const next = value.genres.includes(genre)
                  ? value.genres.filter((g) => g !== genre)
                  : [...value.genres, genre];
                onChange({ genres: next });
              }}
              className={pill(value.genres.includes(genre))}
            >
              {genre}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">年份</h3>
        <div className="flex flex-wrap gap-2">
          {yearOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange({ yearRange: opt.value })}
              className={pill(value.yearRange === opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">地区</h3>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onChange({ region: "" })}
            className={pill(value.region === "")}
          >
            全部地区
          </button>
          {regions.map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => onChange({ region: r })}
              className={pill(value.region === r)}
            >
              {r}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">排序</h3>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange({ sort: opt.value })}
              className={pill(value.sort === opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}